export default "__VITE_ASSET__sGD8KXdb__"